import { Container } from "@mui/material";
import MasonryGallery from "../components/MasonryGallery";

function GalleryPage() {
  return (
    <Container sx={{ py: 4 }}>
      <MasonryGallery />
    </Container>
  )
}

export default GalleryPage;